// Helper modules load statically via controllers/helper/init.ts (embedded partials).
const controllerModules = import.meta.glob('./controllers/*.ts');
const actionModules = import.meta.glob([
    './controllers/*/*.ts',
    '!./controllers/helper/**',
]);

export const importRouteJs = (controller: string, action: string) => {
    if (controller === 'helper') {
        return Promise.resolve([]);
    }

    const loads: Promise<unknown>[] = [];
    const controllerPath = `./controllers/${controller}.ts`;
    if (controllerModules[controllerPath]) {
        loads.push(controllerModules[controllerPath]());
    }
    const actionPath = `./controllers/${controller}/${action}.ts`;
    if (actionModules[actionPath]) {
        loads.push(actionModules[actionPath]());
    }
    return Promise.all(loads);
};

function getBaseUrl() {
  const base = document.querySelector("base");
  if (base) {
    // Remove trailing slash
    return base.href.replace(/\/$/, '');
  }

  return window.location.origin;
}

function getPathName() {
  const baseUrl = getBaseUrl();
  const urlWithPath = window.location.origin + window.location.pathname;

  // remove the retrieved baseUrl from the urlWithPath
  return urlWithPath.replace(baseUrl, '');
}

export const getRoute = () => {
  let [_, controller, action] = getPathName().split('/');

  controller = controller || 'index';
  action = action || 'index';

  // Public campaign URLs (/campaign/:slug) are served by CampaignController but
  // share the payment campaign page script bundle.
  if (controller === 'campaign') {
    return {controller: 'payment', action: 'campaign'};
  }

  return {controller, action};
};

export const {controller, action} = getRoute();
